import {
  GET_CONTACT_EDIT_REQUEST,
  GET_CONTACT_EDIT_SUCCESS,
  GET_CONTACT_EDIT_FAILURE,
  CREATE_CONTACT_REQUEST,
  CREATE_CONTACT_SUCCESS,
  CREATE_CONTACT_FAILURE,
  UPDATE_CONTACT_REQUEST,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_FAILURE,
  RESET_FORM,
  statusType
} from '../../actions'

const initial = {
  data: {},
  status: statusType.IDLE
}

const form = (state = initial, action) => {
  switch (action.type) {
    case CREATE_CONTACT_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case CREATE_CONTACT_SUCCESS:
      return {
        ...state,
        type: action.type,
        data: action.payload,
        status: statusType.SUCCESS
      }

    case CREATE_CONTACT_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    case UPDATE_CONTACT_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case UPDATE_CONTACT_SUCCESS:
      return {
        ...state,
        type: action.type,
        data: action.payload,
        status: statusType.SUCCESS
      }

    case UPDATE_CONTACT_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    case GET_CONTACT_EDIT_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_CONTACT_EDIT_SUCCESS:
      return {
        ...state,
        type: action.type,
        data: action.payload,
        status: statusType.SUCCESS
      }

    case GET_CONTACT_EDIT_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    case RESET_FORM:
      return {
        ...initial
      }

    default:
      return state
  }
}

export default form
